module.exports = __webpack_public_path__ + "img/arrow-left-btn-mouseover.a767dd70.svg";